import axios from 'axios'
import store from '../store'
import createStore from '../store'

const parsedDefaultTimeout = Number(process.env.VUE_APP_API_TIMEOUT_MS)
const defaultTimeout = Number.isFinite(parsedDefaultTimeout) && parsedDefaultTimeout > 0
  ? parsedDefaultTimeout
  : 60000

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
  timeout: defaultTimeout,
})

// Interceptor para adicionar token de autenticação
api.interceptors.request.use(
  (config) => {
    const token = store.state.token
    console.log('🔐 Token disponível:', !!token)
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      console.log('✅ Token adicionado ao header')
    } else {
      console.log('⚠️ Nenhum token disponível')
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Interceptor para renovar token
api.interceptors.response.use(
  (response) => {
    console.log('✅ Resposta da API:', response.config.url, response.status)
    return response
  },
  async (error) => {
    console.log(
      '❌ Erro da API:',
      error.config?.url,
      error.response?.status ?? error.code ?? 'sem_status',
      error.response?.data ?? error.message
    )
    
    const originalRequest = error.config

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      try {
        const refreshToken = store.state.refreshToken
        if (refreshToken) {
          const response = await axios.post('/api/auth/refresh/', {
            refresh: refreshToken
          })
          
          const { access } = response.data
          store.commit('SET_TOKEN', access)
          
          originalRequest.headers.Authorization = `Bearer ${access}`
          return api(originalRequest)
        }
      } catch (refreshError) {
        console.error('Erro ao renovar token:', refreshError)
        // Só fazer logout se não conseguir renovar o token
        store.dispatch('logout')
        window.location.href = '/login'
        return Promise.reject(refreshError)
      }
    }

    return Promise.reject(error)
  }
)

export default api 